<script>
import Subscription from "@/views/administration/subscriber/components/Subscription.vue";
import HamletTable from "@core/components/common/HamletTable.vue";
import dateRenderer from "@core/mixins/date-renderer";
import {Application} from "@/libs/application";
import OngoingDateBadge from "@core/components/common/OngoingDateBadge.vue";
import Button from "@core/components/common/Button.vue";
import { BModal } from 'bootstrap-vue'

export default {
    mixins: [dateRenderer],
    components: {Button, OngoingDateBadge, HamletTable, Subscription, BModal},
    props: {
        subscriptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            table: {
                config: null,
                cb: null
            },
            columns: [
                {
                    key: 'application',
                    label: this.$t('Component(Grid):column-application')
                },
                {
                    key: 'validFrom',
                    label: this.$t('Component(Grid):column-valid-from')
                },
                {
                    key: 'validTo',
                    label: this.$t('Component(Grid):column-valid-to')
                },
            ],
            subscriptionToEdit: null
        }
    },
    methods: {
        onTableCreated(config, cb) {
            this.table.config = config;
            this.table.cb = cb;
        },
        validate() {
            return true;
        },
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;
            cb(
                this.subscriptions.length,
                this.subscriptions.slice(start, start + config.perPage)
            );
        },
        create() {
            this.subscriptionToEdit = this.newSubscription();
            this.openCreateEditSubscriptionModal()
        },
        edit(subscription) {
            this.subscriptionToEdit = subscription;
            this.openCreateEditSubscriptionModal()
        },
        save() {
            if (!this.$refs.subscription.isValid()) {
                return;
            }

            const subscription = this.$refs.subscription.getData();
            if (this.subscriptionToEdit._new) {
                this.$emit('create', subscription);
            } else {
                this.$emit('update', this.subscriptionToEdit, subscription);
            }
        },
        openCreateEditSubscriptionModal() {
            this.$refs.subscriptionModal.show()
            this.$nextTick(() => {
                this.$refs.subscription.populate(this.subscriptionToEdit)
            });
        },
        translateApplication(app) {
            return this.$t(Application.formTranslation(app));
        },
        newSubscription() {
            return {
                _new: true,
                application: null,
                validFrom: null,
                validTo: null,
            };
        }
    },
    watch: {
        subscriptions() {
            this.fetch(this.table.config, this.table.cb);
        }
    }
}
</script>

<template>
    <div>
        <b-modal
            body-class="p-0"
            ref="subscriptionModal"
            centered
            ok-variant="dark"
            ok-only
            @ok="save"
            :title="$t('Component(Button):back')"
            :ok-title="$t('Component(Button):back')"
        >
            <Subscription ref="subscription"/>
        </b-modal>
        <HamletTable
            :columns="columns"
            :fetch="fetch"
            @created="onTableCreated"
            @onRowClick="edit"
        >
            <template #header-label>
                {{ $t('Component(Text):subscription') }}
            </template>

            <template #header-controls>
                <Button
                    @click="create"
                    class="mt-0 btn-icon"
                >
                    <feather-icon icon="PlusIcon" />
                </Button>
            </template>

            <template #cell-application="data">
                {{ data.item.application }}
            </template>

            <template #cell-validFrom="data">
                {{ data.item.validFrom ? renderDate(data.item.validFrom) : '-' }}
            </template>

            <template #cell-validTo="data">
                <OngoingDateBadge
                    :date="data.item.validTo"
                />
            </template>
        </HamletTable>
    </div>
</template>
